<template>
  <div style="width: 100%;height: 100%;background: #f9f9f9;">
    <div id="top">
      <div class="service-btn red-btn" @click="back">
        <span>返回上一页</span>
      </div>
      <!-- <div class="service-btn blue-circle-btn">
        <svg viewBox="0 0 1024 1024" width="32" height="32">
          <path d="M512 64C264.64 64 64 264.64 64 512c0 247.424 200.64 448 448 448 247.488 0 448-200.576 448-448C960 264.64 759.488 64 512 64zM512 768c-26.432 0-48-21.504-48-48S485.568 672 512 672c26.624 0 48 21.504 48 48S538.624 768 512 768zM560 528C560 554.56 538.624 576 512 576 485.568 576 464 554.56 464 528l0-224C464 277.44 485.568 256 512 256c26.624 0 48 21.44 48 48L560 528z" fill="#ffffff"/>
        </svg>
      </div> -->
      <div class="service-btn blue-btn" @click="callService">
        <svg viewBox="0 0 1024 1024" width="20" height="20">
          <path d="M362.403292 95.115814C163.141681 95.115814 0 230.56555 0 403.339212c0 99.329806 54.179894 181.201646 145.081717 244.411523l-36.119929 108.961787 126.419753-63.811875c45.149912 9.029982 81.87184 18.059965 127.021752 18.059965 11.437978 0 22.875955-0.601999 33.711934-1.203998-7.223986-24.079953-11.437978-49.363904-11.437978-75.851852 0-158.325691 136.051734-286.55144 308.223398-286.55144 12.039976 0 23.477954 0.601999 34.915932 2.407995C696.51264 203.475603 540.594944 95.115814 362.403292 95.115814zM240.79953 339.527337c-24.681952 0-44.547913-19.865961-44.547913-44.547913 0-24.681952 19.865961-44.547913 44.547913-44.547913s44.547913 19.865961 44.547913 44.547913C285.347443 319.661376 265.481481 339.527337 240.79953 339.527337zM495.445032 339.527337c-24.681952 0-44.547913-19.865961-44.547913-44.547913 0-24.681952 19.865961-44.547913 44.547913-44.547913s44.547913 19.865961 44.547913 44.547913C539.992945 319.661376 520.126984 339.527337 495.445032 339.527337zM1024 629.69077c0-145.081717-145.081717-263.073486-307.621399-263.073486-172.171664 0-308.223398 117.99177-308.223398 263.073486 0 145.081717 136.051734 263.073486 308.223398 263.073486 36.119929 0 72.239859-9.029982 108.961787-18.059965l99.329806 54.179894-27.089947-90.299824C969.820106 783.802469 1024 711.56261 1024 629.69077zM620.660788 583.938859c-19.865961 0-36.119929-16.253968-36.119929-36.119929s16.253968-36.119929 36.119929-36.119929 36.119929 16.253968 36.119929 36.119929S640.526749 583.938859 620.660788 583.938859zM817.514403 583.938859c-19.865961 0-36.119929-16.253968-36.119929-36.119929s16.253968-36.119929 36.119929-36.119929 36.119929 16.253968 36.119929 36.119929S837.982363 583.938859 817.514403 583.938859z" fill="#02A7F0"/>
        </svg>
        <span>客服热线</span>
      </div>
    </div>
    <van-divider :style="{ color: '#7d7d7d', borderColor: '#7d7d7d', margin: '5px 0' }"/>
    <img style="width:100%" src='../../../assets/serviceHelp.png' />
  </div>
</template>
 
<script>
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    back () {
      this.$router.back();
    },
    callService () {
      this.$alert('如需客服服务支持，请在公众号聊天窗口发送消息即可。')
    }
  },
};
</script>

<style scoped lang="less">
#top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.service-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.red-btn {
  padding: 10px 30px;
  border: 1px solid #FF3300;
  border-radius: 20px;
  span {
    color: #FF3300;
    font-size: 14px;
    font-weight: 500;
  }
}

.blue-circle-btn {
  width: 56px;
  height: 56px;
  background-color: #02A7F0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.blue-btn {
  padding: 10px 20px;
  border: 1px solid #02A7F0;
  border-radius: 20px;
  gap: 8px;
  span {
    color: #02A7F0;
    font-size: 14px;
    font-weight: 500;
  }
}

.backgImg{
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-repeat:no-repeat;
  background-position: center;
  background-image: url("../../../assets/serviceHelp.png");
}
</style>
